// getDeviceType 0  普通手机（默认）
//               1  pad
//               2  J18折叠手机

export const isJ18 = window.MiuiCalendar?.getDeviceType?.() === 2 || 0;
export const isPad = window.MiuiCalendar?.isTabletMode?.() || false;
export const isDarkMode = window.MiuiCalendar?.isDarkMode?.() || false;

// export const isPad = true;
// export const isJ18 = true;
export const smallPad = window.innerWidth <= 400 && isPad;

export const isJ18Full = window.innerWidth > 400 && isJ18;
